// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/poi_detail.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Poi } from "./poi_pb";
import { file_travplaces_v1_poi } from "./poi_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/poi_detail.proto.
 */
export const file_travplaces_v1_poi_detail: GenFile = /*@__PURE__*/
  fileDesc("Ch50cmF2cGxhY2VzL3YxL3BvaV9kZXRhaWwucHJvdG8SDXRyYXZwbGFjZXMudjEiGwoNR2V0UG9pUmVxdWVzdBIKCgJpZBgBIAEoCSIxCg5HZXRQb2lSZXNwb25zZRIfCgNwb2kYASABKAsyEi50cmF2cGxhY2VzLnYxLlBvaSIiChRHZXRQb2lEZXRhaWxzUmVxdWVzdBIKCgJpZBgBIAEoCSLkAQoVR2V0UG9pRGV0YWlsc1Jlc3BvbnNlEh8KA3BvaRgBIAEoCzISLnRyYXZwbGFjZXMudjEuUG9pEikKBnBob3RvcxgCIAMoCzIZLnRyYXZwbGFjZXMudjEuUGxhY2VQaG90bxINCgVwaG9uZRgDIAEoCRIPCgd3ZWJzaXRlGAQgASgJEjIKCGV4dGVybmFsGAUgASgLMiAudHJhdnBsYWNlcy52MS5FeHRlcm5hbFBsYWNlRGF0YRIWCg5sb29rdXBfb3V0Y29tZRgGIAEoCRITCgthdHRyaWJ1dGlvbhgHIAEoCSKaAQoKUGxhY2VQaG90bxILCgN1cmwYASABKAkSFQoId2lkdGhfcHgYAiABKAVIAIgBARIWCgloZWlnaHRfcHgYAyABKAVIAYgBARI1CgxhdHRyaWJ1dGlvbnMYBCADKAsyHy50cmF2cGxhY2VzLnYxLlBob3RvQXR0cmlidXRpb25CCwoJX3dpZHRoX3B4QgwKCl9oZWlnaHRfcHgiQgoQUGhvdG9BdHRyaWJ1dGlvbhIUCgxkaXNwbGF5X25hbWUYASABKAkSEAoDdXJpGAIgASgJSACIAQFCBgoEX3VyaSK7AgoRRXh0ZXJuYWxQbGFjZURhdGESEwoLZXh0ZXJuYWxfaWQYASABKAkSEwoGcmF0aW5nGAIgASgBSACIAQESHgoRdXNlcl9yYXRpbmdfY291bnQYAyABKAVIAYgBARIYCgtwcmljZV9sZXZlbBgEIAEoBUgCiAEBEhQKDHByaW1hcnlfdHlwZRgFIAEoCRIXCg9idXNpbmVzc19zdGF0dXMYBiABKAkSGgoSb3BlbmluZ19ob3Vyc19qc29uGAcgASgJEh0KEG1hdGNoX2NvbmZpZGVuY2UYCCABKAFIA4gBARISCgpleHBpcmVzX2F0GAkgASgJQgkKB19yYXRpbmdCFAoSX3VzZXJfcmF0aW5nX2NvdW50Qg4KDF9wcmljZV9sZXZlbEITChFfbWF0Y2hfY29uZmlkZW5jZTLPAQoQUG9pRGV0YWlsU2VydmljZRJSCgZHZXRQb2kSHC50cmF2cGxhY2VzLnYxLkdldFBvaVJlcXVlc3QaHS50cmF2cGxhY2VzLnYxLkdldFBvaVJlc3BvbnNlIguK6jADCgEKkOowARJnCg1HZXRQb2lEZXRhaWxzEiMudHJhdnBsYWNlcy52MS5HZXRQb2lEZXRhaWxzUmVxdWVzdBokLnRyYXZwbGFjZXMudjEuR2V0UG9pRGV0YWlsc1Jlc3BvbnNlIguK6jADCgEKkOowAUKpAQoRY29tLnRyYXZwbGFjZXMudjFCDlBvaURldGFpbFByb3RvUAFaL3RyYXZwbGFjZXMvZ2VuL3Byb3RvL3RyYXZwbGFjZXMvdjE7dHJhdnBsYWNlc3YxogIDVFhYqgINVHJhdnBsYWNlcy5WMcoCDVRyYXZwbGFjZXNcVjHiAhlUcmF2cGxhY2VzXFYxXEdQQk1ldGFkYXRh6gIOVHJhdnBsYWNlczo6VjFiBnByb3RvMw", [file_travplaces_v1_audit, file_travplaces_v1_authz, file_travplaces_v1_poi]);

/**
 * @generated from message travplaces.v1.GetPoiRequest
 */
export type GetPoiRequest = Message<"travplaces.v1.GetPoiRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.GetPoiRequest.
 * Use `create(GetPoiRequestSchema)` to create a new message.
 */
export const GetPoiRequestSchema: GenMessage<GetPoiRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_poi_detail, 0);

/**
 * @generated from message travplaces.v1.GetPoiResponse
 */
export type GetPoiResponse = Message<"travplaces.v1.GetPoiResponse"> & {
  /**
   * @generated from field: travplaces.v1.Poi poi = 1;
   */
  poi?: Poi | undefined;
};

/**
 * Describes the message travplaces.v1.GetPoiResponse.
 * Use `create(GetPoiResponseSchema)` to create a new message.
 */
export const GetPoiResponseSchema: GenMessage<GetPoiResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_poi_detail, 1);

/**
 * @generated from message travplaces.v1.GetPoiDetailsRequest
 */
export type GetPoiDetailsRequest = Message<"travplaces.v1.GetPoiDetailsRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.GetPoiDetailsRequest.
 * Use `create(GetPoiDetailsRequestSchema)` to create a new message.
 */
export const GetPoiDetailsRequestSchema: GenMessage<GetPoiDetailsRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_poi_detail, 2);

/**
 * @generated from message travplaces.v1.GetPoiDetailsResponse
 */
export type GetPoiDetailsResponse = Message<"travplaces.v1.GetPoiDetailsResponse"> & {
  /**
   * @generated from field: travplaces.v1.Poi poi = 1;
   */
  poi?: Poi | undefined;

  /**
   * The provider's photographs, as URLs this API serves rather than as the
   * provider's own references: a reference is a billable handle the browser
   * has no use for, and the redirect endpoint is the only thing that should
   * ever hold one.
   *
   * @generated from field: repeated travplaces.v1.PlacePhoto photos = 2;
   */
  photos: PlacePhoto[];

  /**
   * @generated from field: string phone = 3;
   */
  phone: string;

  /**
   * @generated from field: string website = 4;
   */
  website: string;

  /**
   * What the place provider knows, when it has been asked and believed.
   *
   * @generated from field: travplaces.v1.ExternalPlaceData external = 5;
   */
  external?: ExternalPlaceData | undefined;

  /**
   * Why there is no provider data, when there is none. "never" nobody has
   * looked · "not-found" looked, nothing there · "unconfirmed" looked, and
   * the answer was a different place · "matched" looked and believed.
   *
   * The three failure states are kept apart because they mean different
   * things: an unexamined place is not the same as one the provider has never
   * heard of, and neither is the same as a bad match.
   *
   * @generated from field: string lookup_outcome = 6;
   */
  lookupOutcome: string;

  /**
   * Required wherever provider content is displayed, and sent from here so
   * the client cannot forget it. Keyed to the TRUSTED record: a match that
   * was rejected puts nothing of theirs on screen, and crediting them for
   * content that is not shown is as wrong as showing it uncredited.
   *
   * @generated from field: string attribution = 7;
   */
  attribution: string;
};

/**
 * Describes the message travplaces.v1.GetPoiDetailsResponse.
 * Use `create(GetPoiDetailsResponseSchema)` to create a new message.
 */
export const GetPoiDetailsResponseSchema: GenMessage<GetPoiDetailsResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_poi_detail, 3);

/**
 * PlacePhoto is one photograph, as a URL the app can load directly.
 *
 * @generated from message travplaces.v1.PlacePhoto
 */
export type PlacePhoto = Message<"travplaces.v1.PlacePhoto"> & {
  /**
   * Served by this API, which redeems the provider's short-lived signed URL
   * and redirects — so the API key never reaches the browser.
   *
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: optional int32 width_px = 2;
   */
  widthPx?: number | undefined;

  /**
   * @generated from field: optional int32 height_px = 3;
   */
  heightPx?: number | undefined;

  /**
   * Whoever took it. Must be shown wherever the picture is, which is why it
   * travels with the photograph rather than being looked up separately.
   *
   * @generated from field: repeated travplaces.v1.PhotoAttribution attributions = 4;
   */
  attributions: PhotoAttribution[];
};

/**
 * Describes the message travplaces.v1.PlacePhoto.
 * Use `create(PlacePhotoSchema)` to create a new message.
 */
export const PlacePhotoSchema: GenMessage<PlacePhoto> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_poi_detail, 4);

/**
 * @generated from message travplaces.v1.PhotoAttribution
 */
export type PhotoAttribution = Message<"travplaces.v1.PhotoAttribution"> & {
  /**
   * @generated from field: string display_name = 1;
   */
  displayName: string;

  /**
   * @generated from field: optional string uri = 2;
   */
  uri?: string | undefined;
};

/**
 * Describes the message travplaces.v1.PhotoAttribution.
 * Use `create(PhotoAttributionSchema)` to create a new message.
 */
export const PhotoAttributionSchema: GenMessage<PhotoAttribution> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_poi_detail, 5);

/**
 * ExternalPlaceData is one place as the provider records it.
 *
 * @generated from message travplaces.v1.ExternalPlaceData
 */
export type ExternalPlaceData = Message<"travplaces.v1.ExternalPlaceData"> & {
  /**
   * @generated from field: string external_id = 1;
   */
  externalId: string;

  /**
   * @generated from field: optional double rating = 2;
   */
  rating?: number | undefined;

  /**
   * @generated from field: optional int32 user_rating_count = 3;
   */
  userRatingCount?: number | undefined;

  /**
   * @generated from field: optional int32 price_level = 4;
   */
  priceLevel?: number | undefined;

  /**
   * @generated from field: string primary_type = 5;
   */
  primaryType: string;

  /**
   * @generated from field: string business_status = 6;
   */
  businessStatus: string;

  /**
   * The provider's structured weekly hours, as JSON. Shape varies by
   * provider, so the client reads it defensively.
   *
   * @generated from field: string opening_hours_json = 7;
   */
  openingHoursJson: string;

  /**
   * @generated from field: optional double match_confidence = 8;
   */
  matchConfidence?: number | undefined;

  /**
   * @generated from field: string expires_at = 9;
   */
  expiresAt: string;
};

/**
 * Describes the message travplaces.v1.ExternalPlaceData.
 * Use `create(ExternalPlaceDataSchema)` to create a new message.
 */
export const ExternalPlaceDataSchema: GenMessage<ExternalPlaceData> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_poi_detail, 6);

/**
 * PoiDetailService returns a single POI and its (externally-enriched) details.
 *
 * @generated from service travplaces.v1.PoiDetailService
 */
export const PoiDetailService: GenService<{
  /**
   * GetPoi returns one POI by id.
   *
   * @generated from rpc travplaces.v1.PoiDetailService.GetPoi
   */
  getPoi: {
    methodKind: "unary";
    input: typeof GetPoiRequestSchema;
    output: typeof GetPoiResponseSchema;
  },
  /**
   * GetPoiDetails returns one POI plus enrichment (photos, phone, website).
   *
   * @generated from rpc travplaces.v1.PoiDetailService.GetPoiDetails
   */
  getPoiDetails: {
    methodKind: "unary";
    input: typeof GetPoiDetailsRequestSchema;
    output: typeof GetPoiDetailsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_poi_detail, 0);

